import { ComponentProps } from 'lib/component-props';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';

const Link = ({ fields }: ComponentProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  return (
    (sitecoreContext.pageEditing || fields?.link?.value) && (
      <div className="my-3">
        <ScLink className="revert-underline text-link background-to-change" field={fields.link} />
      </div>
    )
  );
};

export default Link;
